/* eslint-disable import/no-unresolved, import/extensions */
import BaseFields from 'react-jsonschema-form/lib/components/fields';
import ParagraphField from './ParagraphField';

export default {
  ...BaseFields,
  ParagraphField,
};
